import axios from 'axios'
import { defineStore } from 'pinia'

import { axGet } from './../utils/fetch_helpers'
import * as storage from './../utils/storage.js'

const baseUrl = `${process.env.VUE_APP_PIPES}/common/tags`

export const useTagStore = defineStore('tagUser', {
  state: () => ({
    tags: [],
  }),

  getters: {
    getTags: state => state.tags,
    toSimpleList: state => state.tags.map(t => t.label),
  },

  actions: {
    fetch() {
      return axGet(baseUrl).then(
        r => {
          this.tags = r.results
          return r
        },
        e => {
          return e
        }
      )
    },
  },
})
